import { createResource } from '@frappe-ui/resources/resources.js'

export function createAppVersionResource() {
  return createResource({
    url: 'retiora.api.session.get_app_version',
    initialData: { version: '' },
    auto: true,
  })
}
